<template>
  <div
    class="relative flex flex-col min-w-0 break-words w-full mb-6 shadow-lg rounded"
    :class="[color === 'light' ? 'bg-white' : 'bg-emerald-900 text-white']"
  >
    <card-month-nav
      :title="title"
      :subtitle="subtitle"
      :color="color"
    ></card-month-nav>

    <div class="block w-full overflow-x-auto">
      <table
        class="table-fixed items-center w-full bg-transparent border-collapse"
      >
        <thead>
          <tr>
            <th
              v-for="(day, index) in dayNames"
              :key="index"
              class="px-6 align-middle text-center border border-solid py-3 text-sm uppercase border-l-0 border-r-0 font-semibold text-left"
              :class="[
                color === 'light'
                  ? 'bg-blueGray-50 text-blueGray-500 border-blueGray-100'
                  : 'bg-emerald-800 text-emerald-300 border-emerald-700',
              ]"
              :width="(1 / dayNames.length) * 100 + '%'"
            >
              {{ $t("days." + day) }}
            </th>
          </tr>
        </thead>
        <tbody>
          <tr v-for="(week, indexWeek) in weeks" :key="indexWeek">
            <td
              v-for="(date, indexDate) in week"
              :key="indexDate"
              class="p-3 align-top text-sm border border-solid overflow-hidden"
              :class="
                date.date
                  ? feriadosMapByMonthAndDate[date.key]
                    ? 'bg-yellow-100'
                    : ''
                  : color === 'light'
                  ? 'bg-blueGray-50 text-blueGray-500 border-blueGray-100'
                  : 'bg-emerald-800 text-emerald-300 border-emerald-700'
              "
            >
              <div class="h-24 overflow-y-auto">
                <button
                  v-if="isEnableToAddRecords(date)"
                  @click="newRecord(date)"
                  class="float-left bg-lightBlue-500 text-white font-bold uppercase text-xs px-2 py-1 rounded shadow hover:shadow-md outline-none focus:outline-none mb-1 ease-linear transition-all duration-150"
                >
                  +
                </button>
                <template v-if="date.date">
                  <div class="pb-3">
                    <p class="text-right text-blueGray-400 pb-3">
                      {{ date.date }}
                    </p>
                    <p
                      v-for="feriado in feriadosMapByMonthAndDate[date.key]"
                      :key="feriado.idferiado"
                    >
                      {{ feriado.nombre }}
                    </p>
                  </div>
                </template>

                <div
                  v-for="record in recordsMapByDate[date.key]"
                  :key="record.idhora"
                >
                  <div
                    class="text-white font-bold uppercase text-xs px-4 py-2 rounded shadow hover:shadow-md outline-none focus:outline-none mb-1 ease-linear transition-all duration-150"
                    :class="[
                      record._type === 'hora'
                        ? 'cursor-pointer bg-emerald-500'
                        : 'bg-blueGray-500',
                    ]"
                    @click="openRecord(record)"
                    :title="record._type === 'hora' ? 'Abrir registro' : ''"
                  >
                    <div v-if="record._type === 'hora'">{{ record.tarea }}</div>
                    <div v-else>{{ record.motivo }}</div>
                    <div>
                      <small>{{ record.presupuesto?.slice(0, 10) }}</small>
                    </div>
                    {{ removeTrailingZeros(record.horas) }} hs
                  </div>
                </div>
              </div>
            </td>
          </tr>
        </tbody>
      </table>
    </div>
  </div>
</template>
<script>
import { mapState } from 'vuex';
import CardMonthNav from "@/components/Cards/CardMonthNav.vue";
import ReporteService from "@/services/reporte.service";
import DateUtils from '@/utils/dateUtils';
import NumberUtils from "@/utils/numberUtils"

export default {

  components: {
    CardMonthNav,
  },

  data() {
    return {
      dayNames: [
        'Lunes', 'Martes', 'Miércoles', 'Jueves', 'Viernes', 'Sábado', 'Domingo'
      ],
      weeks: {},
      columnTarea: {
        label: "Tarea",
        name: "idtarea",
        type: "tarea",
      },
      records: [],
      feriados: [],
      licencias: []
    };
  },

  props: {
    title: {},
    subtitle: {},
    idpersonal: {},
    color: {
      default: "light",
      validator: function (value) {
        // The value must match one of these strings
        return ["light", "dark"].indexOf(value) !== -1;
      },
    },
  },

  computed: {
    ...mapState({
      userInfo: state => state.auth.user,
      startDateFromState: state => state.filters.startDate,
      endDateFromState: state => state.filters.endDate,
    }),

    isPersonal() {
      const roles = this.userInfo?.roles || [];
      return roles.includes('personal');
    },

    linkHoras(){
      return this.isPersonal ? '/mis-horas' : '/horas';
    },

    dateFilter() {
      const dateFilter = DateUtils.stringToDate(this.startDateFromState || this.endDateFromState);
      return dateFilter;
    },

    year() {
      return this.dateFilter?.getFullYear();
    },

    month() {
      return this.dateFilter?.getMonth(); // base 0
    },

    recordsMapByDate() {
      const recordsMapByDate = {};

      this.records?.forEach(record => {
        if (!recordsMapByDate[record.fecha]) {
          recordsMapByDate[record.fecha] = [];
        }
        recordsMapByDate[record.fecha].push({
          ...record,
          _type: 'hora'
        });
      });

      this.licencias?.forEach(licencia => {
        if (!recordsMapByDate[licencia.fecha]) {
          recordsMapByDate[licencia.fecha] = [];
        }
        recordsMapByDate[licencia.fecha].push({
          ...licencia,
          _type: 'licencia'
        });
      });

      return recordsMapByDate;
    },

    feriadosMapByMonthAndDate() {
      const feriadosMapByMonthAndDate = {};

      this.feriados?.forEach(feriado => {
        if (!feriadosMapByMonthAndDate[feriado.fecha]) {
          feriadosMapByMonthAndDate[feriado.fecha] = [];
        }
        feriadosMapByMonthAndDate[feriado.fecha].push(feriado);
      });

      return feriadosMapByMonthAndDate;
    }
  },

  mounted() {
    this.loadWeeks();
    this.loadRecords();
  },

  watch: {
    $route: {
      immediate: true,
      handler() {
        ["year", "month"].forEach(property => {
          this.$watch(
            () => this[property],
            () => {
              this.loadWeeks();
              this.loadRecords();
            }
          );
        });
      }
    }
  },

  methods: {
    loadWeeks() {
      if (!this.year || !(this.month >= 0)) {
        this.weeks = [];
        return;
      }

      const startDate = new Date(this.year, this.month, 1);
      const endDate = new Date(this.year, this.month + 1, 0);
      let offset = startDate.getDay() - 1;
      const weeks = [];
      let dates = [];

      if (offset < 0) {
        offset += 7;
      }

      for (let i = 0; i < offset; i++) {
        dates.push({});
      }

      for (let date = startDate; date <= endDate; date.setDate(date.getDate() + 1)) {
        dates.push({
          date: date.getDate(),
          month: date.getMonth(), // base 0
          year: date.getFullYear(),
          key: DateUtils.dateToString(date)
        });
        if (dates.length === 7) {
          weeks.push(dates);
          dates = [];
        }
      }

      if (dates.length > 0) {
        for (let i = dates.length; i < 7; i++) {
          dates.push({});
        }
        weeks.push(dates);
      }

      this.weeks = weeks;
    },

    newRecord(date) {
      const selectedDay = new Date(date.year, date.month, date.date);
      this.$router.push(`${this.linkHoras}/new?fecha=${DateUtils.formatDate(selectedDay)}`);
    },

    openRecord(record) {
      if (record._type === 'hora') {
        this.$router.push(`${this.linkHoras}/${record.idhora}`);
      }
    },

    isEnableToAddRecords(date) {
      if (!date.year || !(date.month >= 0) || !date.date) {
        return false;
      }

      const selectedDay = new Date(date.year, date.month, date.date);
      const currentDate = new Date();

      let startLimit = new Date(
        currentDate.getFullYear(),
        currentDate.getMonth(),
        currentDate.getDate() - 6
      );

      // if (currentDate.getMonth() > startLimit.getMonth()) {
      //   startLimit = new Date(
      //     currentDate.getFullYear(),
      //     currentDate.getMonth(),
      //     1
      //   );
      // }

      const endLimit = new Date(
        currentDate.getFullYear(),
        currentDate.getMonth(),
        currentDate.getDate() + (this.isPersonal ? 1 : 11)
      );

      return startLimit < selectedDay && selectedDay < endLimit;
    },

    loadRecords() {
      if (!this.year || !(this.month >= 0)) {
        this.records = [];
        this.feriados = [];
        this.licencias = [];
        return;
      }

      const startDate = DateUtils.formatDate(new Date(this.year, this.month, 1));
      const endDate = DateUtils.formatDate(new Date(this.year, this.month + 1, 0));
      const idpersonal = this.idpersonal;

      ReporteService.horasPorScheduler({ startDate, endDate, idpersonal })
        .then((data) => {
          this.records = data.horas;
          this.feriados = data.feriados;
          this.licencias = data.licencias;
        })
        .catch((response) => {
          console.log(response);
        });
    },

    removeTrailingZeros(params) {
      return NumberUtils.removeTrailingZeros(params);
    }
  }
};
</script>
